import { render, staticRenderFns } from "./herdsmanEdit.vue?vue&type=template&id=0987fd8a&scoped=true"
import script from "./herdsmanEdit.vue?vue&type=script&lang=js"
export * from "./herdsmanEdit.vue?vue&type=script&lang=js"
import style0 from "./herdsmanEdit.vue?vue&type=style&index=0&id=0987fd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987fd8a",
  null
  
)

export default component.exports